import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import ProfileBrief from "./ProfileBrief"
import ProgressTracker from "./ProgressTracker"
import Announcements from "./Announcements"
import ProgressStandingNotice from "../../ProgressStandingNotice"
import { ReapplyPathOfferPanel } from "../../ReapplyPathOffer"
import { MembershipJourneyProvider } from "./MembershipJourneyContext"
import { resolveAcceptableProgressStanding } from "../../../utils/resolveAcceptableProgressStanding"
import { LEVEL } from "./utils/constants/levels"
import {
  DashboardContainer,
  ContentGrid,
  MainContent,
  SidebarContent,
} from "./Styles/Dashboard.styles"

const MembershipJourneyDashboard = ({
  me,
  pgmProgress,
  onEditProfile,
  history,
  authReady,
}) => {
  const initialLevel = pgmProgress?.currentLevelKey || LEVEL.QUALIFYING
  const [activeLevel, setActiveLevel] = useState(initialLevel)

  const handleEditClick = () => {
    if (onEditProfile) {
      onEditProfile()
    } else if (history) {
      history.push("/profile/edit")
    } else {
      window.location.href = "/profile/edit"
    }
  }

  const progressStanding = resolveAcceptableProgressStanding({
    me,
    pgmProgress,
  })

  const contextValue = {
    me,
    pgaId: me?.pgaId,
    pgmProgress,
    progressStanding,
  }

  return (
    <MembershipJourneyProvider value={contextValue}>
      <DashboardContainer>
        <ProfileBrief me={me} onEditClick={handleEditClick} authReady={true} />
        <ProgressStandingNotice standing={progressStanding} />
        <ReapplyPathOfferPanel me={me} standing={progressStanding} />
        <ContentGrid>
          <MainContent>
            <ProgressTracker
              activeLevel={activeLevel}
              onLevelClick={setActiveLevel}
            />
          </MainContent>
          <SidebarContent>
            <Announcements
              mainProgramTypeCode={me?.mainProgramTypeCode}
              sectionName={me?.primarySection?.name}
              authReady={authReady}
            />
          </SidebarContent>
        </ContentGrid>
      </DashboardContainer>
    </MembershipJourneyProvider>
  )
}

export default withRouter(MembershipJourneyDashboard)
